import { render } from "./HeroSection.vue?vue&type=template&id=6ab48abe"
import script from "./HeroSection.vue?vue&type=script&lang=js"
export * from "./HeroSection.vue?vue&type=script&lang=js"
script.render = render

export default script